import { SIZE, FONT_NORMAL } from './constants';
const getFontStyles = ({ size, theme, kind }) => {
    const { labelSmall, bodyMedium, subTitleMedium, subTitleLarge, titleXSmall, titleMedium, } = theme.typography;
    switch (size) {
        case SIZE.small_alt:
            if (kind === FONT_NORMAL) {
                return Object.assign({}, labelSmall);
            }
            return Object.assign({}, titleMedium);
        case SIZE.small:
            if (kind === FONT_NORMAL) {
                return Object.assign({}, subTitleMedium);
            }
            return Object.assign({}, titleXSmall);
        case SIZE.medium:
            if (kind === FONT_NORMAL) {
                return Object.assign({}, subTitleLarge);
            }
            return Object.assign({}, titleMedium);
        default:
            return Object.assign({}, bodyMedium);
    }
};
const calculateHeight = (hasDynamicHeight, cardHeight, originalHeight) => {
    if (hasDynamicHeight && cardHeight) {
        return cardHeight;
    }
    return originalHeight;
};
const generateId = (str) => {
    const trimmedString = str === null || str === void 0 ? void 0 : str.trim();
    const hyphenString = trimmedString === null || trimmedString === void 0 ? void 0 : trimmedString.replace(/ /g, '-');
    const id = hyphenString === null || hyphenString === void 0 ? void 0 : hyphenString.toLowerCase();
    return String(id);
};
const objectEqualiser = (targetObj = {}, defaultObj = {}) => {
    const res = {};
    const keys = Object.keys(defaultObj);
    for (let index = 0; index < keys.length; index += 1) {
        const key = keys[index];
        const value = targetObj[key];
        const defaultValue = defaultObj[key];
        if (!value && defaultValue) {
            res[key] = defaultValue;
        }
        else {
            res[key] = value;
        }
    }
    return res;
};
export const calculateStarStatus = ({ index, fullStars, rating, }) => {
    const halfStar = index >= fullStars && (rating > fullStars);
    const emptyStar = index >= Math.ceil(rating);
    return { halfStar, emptyStar };
};
export { getFontStyles, calculateHeight, generateId, objectEqualiser, };
